import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

// Staff management calls the admin-only Cloud Functions. Each function verifies
// the caller's admin claim server-side, so these are safe to expose in the UI.

export interface ManagedUser {
  uid: string;
  email: string;
  admin: boolean;
  disabled: boolean;
  createdAt: string;
  lastSignIn: string | null;
}

const listStaffFn = httpsCallable<unknown, { users: ManagedUser[] }>(functions, "listStaff");
const createStaffFn = httpsCallable<
  { email: string; password: string; admin: boolean }, { user: ManagedUser }
>(functions, "createStaff");
const setStaffAdminFn = httpsCallable<{ uid: string; admin: boolean }, { user: ManagedUser }>(functions, "setStaffAdmin");
const setStaffPasswordFn = httpsCallable<{ uid: string; password: string }, { ok: true }>(functions, "setStaffPassword");
const deleteStaffFn = httpsCallable<{ uid: string }, { ok: true }>(functions, "deleteStaff");

export async function listStaff(): Promise<ManagedUser[]> {
  return (await listStaffFn({})).data.users;
}

export async function createStaff(email: string, password: string, admin: boolean): Promise<ManagedUser> {
  return (await createStaffFn({ email, password, admin })).data.user;
}

export async function setStaffAdmin(uid: string, admin: boolean): Promise<ManagedUser> {
  return (await setStaffAdminFn({ uid, admin })).data.user;
}

export async function setStaffPassword(uid: string, password: string): Promise<void> {
  await setStaffPasswordFn({ uid, password });
}

export async function deleteStaff(uid: string): Promise<void> {
  await deleteStaffFn({ uid });
}

// Echo only curated server messages; otherwise a generic line.
const SAFE_CODES = new Set([
  "functions/failed-precondition",
  "functions/already-exists",
  "functions/invalid-argument",
  "functions/permission-denied",
]);
export function friendlyUserError(err: unknown, fallback: string): string {
  const code = (err as { code?: string })?.code;
  const message = err instanceof Error ? err.message : "";
  if (code && SAFE_CODES.has(code) && message) return message;
  return fallback;
}
